import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateRoleAssignmentBody,
  type CreateRoleAssignmentV1RoleAssignmentsPostError,
  type RoleAssignmentView,
  createRoleAssignmentV1RoleAssignmentsPost,
} from '../../generated';

export type CreateRoleAssignmentMutationVariables = CreateRoleAssignmentBody;

export type CreateRoleAssignmentMutation = RoleAssignmentView;

export const useCreateRoleAssignmentMutation = <
  TError = CreateRoleAssignmentV1RoleAssignmentsPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateRoleAssignmentMutation, TError, CreateRoleAssignmentMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateRoleAssignmentMutation, TError, CreateRoleAssignmentMutationVariables, TContext>({
    mutationKey: ['CreateRoleAssignment'],
    mutationFn: async (body: CreateRoleAssignmentMutationVariables) => {
      const { data } = await createRoleAssignmentV1RoleAssignmentsPost({
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateRoleAssignmentMutation.fetcher = (
  body: CreateRoleAssignmentMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createRoleAssignmentV1RoleAssignmentsPost({
      body,
      throwOnError: true,
    });
    return data;
  };
};
